import type {SVGProps} from 'react'

const SvgElectricLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={48}
    height={48}
    fill={'none'}
    viewBox={'0 0 49 48'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M.9 16a1.6 1.6 0 0 1 1.6-1.6h23a1.6 1.6 0 0 1 1.6 1.6v9.778C27.1 32.872 21.222 38.6 14 38.6S.9 32.872.9 25.778zm1.6-.4a.4.4 0 0 0-.4.4v9.778C2.1 32.184 7.415 37.4 14 37.4s11.9-5.216 11.9-11.622V16a.4.4 0 0 0-.4-.4z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M20.6 7v8h-1.2V7zM8.6 7v8H7.4V7zM13.443 20.777l1.114.446-1.67 4.177h4l-2.33 5.823-1.114-.446 1.67-4.177h-4z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgElectricLarge
